export default {
  beamType: {
    notes: 'Exciter beam type / position',
    message: 'Beam',
    values: {
      exciter_beam: {
        notes:
          'Display name for exciter beam default type (legacy single beam)',
        message: 'Default beam',
      },
      exciter_beam_center: {
        notes: 'Display name for exciter beam type center (three beams)',
        message: 'Center',
      },
      exciter_beam_discharge: {
        notes:
          'Display name for exciter beam type discharge (two or three beams)',
        message: 'Discharge',
      },
      exciter_beam_feed: {
        notes:
          'Display name for exciter beam type feed (one, two or three beams)',
        message: 'Feed',
      },
    },
  },
  driveSide: {
    notes: 'Drive side for an exciter beam',
    message: 'Drive side',
    values: {
      left: {
        notes: 'Display name for exciter beam drive side left',
        message: 'Left',
      },
      right: {
        notes: 'Display name for exciter beam drive side right',
        message: 'Right',
      },
    },
  },
};
